<template>
  <v-container>
    <PageHeading title="Bookings Calendar" no-return />
    <EventCalendar class="mt-4" v-bind="calendar" />
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ServiceBooking, ServiceSchedule } from "~/models/dobby/Service";

export default defineComponent({
  setup() {
    definePageMeta({
      rememberNav: "Booking calendar",
    });

    const scheduleQuery = ServiceSchedule.defaultQuery();
    const bookingQuery = ServiceBooking.calendarDisplayQuery();

    const schedules = useListQuery<ServiceSchedule>(scheduleQuery);
    const bookings = useListQuery<ServiceBooking>(bookingQuery);

    const loading = computed(
      () => schedules.loading.value || bookings.loading.value
    );

    const calendar = computed(() => {
      return defineCalendar({
        loading: loading.value,
        schedules: schedules.items.value,
        bookings: bookings.items.value,
      });
    });

    return {
      loading,
      calendar,
    };
  },
});
</script>
